import { takeLatest, call, put, select } from "redux-saga/effects"
import {
  getPlansWatcher,
  getPlansSuccess,
  getPlansFailed,
  updatePhotoSuccess,
} from "./actions"
import { GET_PLANS_WATCHER, UPDATE_PHOTO_WATCHER } from "./constants"

// GET PLANS
export function* getPlansSaga(action) {
  try {
    const {
      data: {
        data: { result },
      },
    } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: "employees/teamleader/profile/",
      params: action.payload,
    })
    yield put(
      getPlansSuccess({
        team_leader: result.team_leader,
        leader: result.leader,
      })
    )
    yield put(updatePhotoSuccess())
  } catch (error) {
    returnMessage(error)
    getPlansFailed({})
  }
}

export function* updatePhotoSaga(action) {
  try {
    const response = yield call(fetchGlobalApi, {
      method: "post",
      endpoint: `employees/teamleader/${action.payload.get("id")}/updatePhoto`,
      data: action.payload,
    })

    yield put(getPlansWatcher({ id_employee: action.payload.get("id") }))
  } catch (error) {
    yield put(updatePhotoSuccess())
  }
}

// Individual exports for testing
export default function* profileLeaderSaga() {
  yield takeLatest(GET_PLANS_WATCHER, getPlansSaga)
  yield takeLatest(UPDATE_PHOTO_WATCHER, updatePhotoSaga)
}
